import {
  HttpEvent,
  HttpEventType,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { IFlashyServerResponse } from '@flashy/store';
import { FlashyTokenService } from '@flashy/users/data-access';
import { ModalsService } from '@services/modals/modals.service';

export interface IShowMessageInterface {
  redirect_url?: string;
  token?: string;
  show_message: boolean;
  title: string;
  message: string;
}

function eventIsResponse(
  event: HttpEvent<unknown>
): event is HttpResponse<IFlashyServerResponse<IShowMessageInterface>> {
  return event.type === HttpEventType.Response;
}

export const showMessageInterceptor: HttpInterceptorFn = (
  req: HttpRequest<IFlashyServerResponse<IShowMessageInterface>>,
  next: HttpHandlerFn
) => {
  const modalsService = inject(ModalsService);
  const tokenService = inject(FlashyTokenService);
  return next(req).pipe(
    switchMap((event) => {
      if (eventIsResponse(event) && event.body.data?.show_message) {
        if (event.body.data?.token) {
          tokenService.token = event.body.data.token;
        }
        if (event.body.data?.show_message) {
          return modalsService
            .showMessage(event.body.data)
            .pipe(switchMap(() => EMPTY));
        }
      } else {
        return of(event);
      }
    })
  );
};
